import _ from 'lodash'

export default class RejectedEvents {
  constructor(data) {
    this.data = data
  }

  call() {
    this.templateWrapper.innerHTML = this.parseTemplate()
    this.setTemplateTableWrapper()
    this.setFilterEventTypes()
    this.setFilterRejectReason()
    this.setFilterBudget()
    this.bindingFilterEventType()
    this.bindingFilterRejectReason()
    this.bindingFilterBudget()
  }

  setTemplateTableWrapper () {
    this.templateTableWrapper.innerHTML = this.parseTemplateTable()
  }

  bindingFilterEventType () {
    let classDefine = this

    this.filterEventTypeWrapper.addEventListener('change', function() {
      classDefine.setTemplateTableWrapper()
    })
  }

  bindingFilterRejectReason () {
    let classDefine = this

    this.filterRejectReasonWrapper.addEventListener('change', function() {
      classDefine.setTemplateTableWrapper()
    })
  }

  bindingFilterBudget () {
    let classDefine = this

    this.filterBudgetWrapper.addEventListener('change', function() {
      classDefine.setTemplateTableWrapper()
    })
  }

  setFilterEventTypes () {
    let classDefine = this

    this.dataEventTypes.forEach(function(item, index) {
      let option = document.createElement("option");
      option.value = item
      option.innerHTML = item
      classDefine.filterEventTypeWrapper.append(option)
    });
  }

  setFilterRejectReason () {
    let classDefine = this

    this.dataRejectReason.forEach(function(item, index) {
      let option = document.createElement("option");
      option.value = item
      option.innerHTML = item
      classDefine.filterRejectReasonWrapper.append(option)
    });
  }

  setFilterBudget () {
    let classDefine = this
    
    this.dataBudget.forEach(function(item, index) {
      let option = document.createElement("option");
      option.value = item.value
      option.innerHTML = item.label
      classDefine.filterBudgetWrapper.append(option)
    });
  }

  parseTemplate() {
    _.templateSettings = {
      evaluate:    /\{\{(.+?)\}\}/g,
      interpolate: /\{\{=(.+?)\}\}/g,
      escape:      /\{\{-(.+?)\}\}/g
    };

    let compiled = _.template(this.template.innerHTML)

    return compiled(this.compiledData)
  }

  parseTemplateTable() {
    let htmlTemplate = ''
    _.templateSettings = {
      evaluate:    /\{\{(.+?)\}\}/g,
      interpolate: /\{\{=(.+?)\}\}/g,
      escape:      /\{\{-(.+?)\}\}/g
    };

    let compiled = _.template(this.templateTable.innerHTML)
    this.dataEvents.forEach(function(item, _index) {
      htmlTemplate += compiled(item)
    });

    return htmlTemplate;
  }

  get compiledData () {
    let data = {}

    data['average_daily_rate'] = this.data.average_daily_rate
    data['average_response_time'] = this.data.average_response_time
    data['revenue'] = this.data.revenue
    data['total_inquiries'] = this.data.total_inquiries

    return data
  }

  get templateWrapper() {
    return document.getElementById('nav-rejected')
  }

  get template() {
    return document.getElementById('template-rejected')
  }

  get templateTableWrapper() {
    return document.querySelector('table#rejected-event-table tbody')
  }

  get templateTable() {
    return document.getElementById('template-rejected-table')
  }

  get filterEventTypeWrapper() {
    return document.getElementById('eventtype2')
  }

  get filterRejectReasonWrapper() {
    return document.getElementById('rejectReason')
  }

  get filterBudgetWrapper() {
    return document.getElementById('budget2')
  }

  get dataEvents() {
    let data = this.data.data_events
    let eventType = this.filterEventTypeWrapper.value
    let rejectReason = this.filterRejectReasonWrapper.value
    let budget = this.filterBudgetWrapper.value


    if(eventType) {
      data = _.filter(data, function(item) { return item.event_type == eventType })
    }

    if(rejectReason) {
      data = _.filter(data, function(item) { return item.reject_reason == rejectReason })
    }

    if (budget) {
      let budget_down = budget.split("-")[0];
      let budget_up = budget.split("-")[1];

      data = _.filter(data, function(item) {
        if (budget_down == '<') {
          return parseInt(item.budget) < parseInt(budget_up)
        } else if (budget_up == '>') {
          return parseInt(item.budget) > parseInt(budget_down)
        } else {
          return parseInt(item.budget) >= parseInt(budget_down) && parseInt(item.budget) <= parseInt(budget_up)
        }
      })
    }

    return data
  }

  get dataEventTypes() {
    return _.uniq(_.map(this.data.data_events, 'event_type'))
  }

  get dataRejectReason() {
    return _.uniq(_.map(this.data.data_events, 'reject_reason'))
  }

  get dataBudget() {
    return this.data.data_budgets
  }
}
